export default {
    fnsoum: '',
    frefc: '',
    fcol: '',
    fstatus: 'O',
    fdate_soum: '',
    launch_research: false,
    reset_submission_list: false,
    fcetat: '@',
    fcetatd: 'D',
    fcetate: 'E',
    fcetata: 'A',
    fcetatr: 'R',
    fcetatt: '',
    fcetat_sup: ''
};